import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import Header from "layouts/profile/components/Header";
import Grid from "@mui/material/Grid";
import SuiBox from "components/SuiBox";
import SuiTypography from 'components/SuiTypography';
import SuiButton from 'components/SuiButton';
import {
  ProjectsUpcoming,
  ProjectsPast,
} from "layouts/event/components/Projects/indexAdminUpcoming";
import Modal from '@mui/material/Modal';
import axios from 'axios';
import uploadGif from 'assets/images/upload.gif';
import uploadJson from 'assets/images/upload.json';
import Icon from "@mui/material/Icon";
import Card from "@mui/material/Card";
import { usePapaParse } from "react-papaparse"

// Soft UI Dashboard React examples
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
//import Footer from "examples/Footer";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import gradientLineChartData from "layouts/dashboard/data/gradientLineChartData";

// Dashboard layout components
import BuildByDevelopers from "layouts/dashboard/components/BuildByDevelopers";
import WorkWithTheRockets from "layouts/dashboard/components/WorkWithTheRockets";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';


// Soft UI Dashboard React base styles
import typography from "assets/theme/base/typography";
import Table from "layouts/event/components/Table";
import { useNavigate } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import { useSnackbar } from "notistack";
import Lottie from 'lottie-react';
import { use } from 'react';


function Overview() {
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [accStatus, setAccStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [username, setUsername] = useState('');
  const [tenant, setTenant] = useState('');
  const [eventCount, setEventCount] = useState(0);
  const [certCount, setCountCert] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const { size } = typography;
  const { chart, items } = reportsBarChartData;
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [subscriptionPlan, setSubPlan] = useState('');
  const { readRemoteFile } = usePapaParse();

  useEffect(() => {
    Auth.currentUserInfo()
      .then((value) => {
        const approvalStatus = value.attributes["custom:approvalStatus"];
        const accStatus = value.attributes["custom:accStatus"];
        const email = value.attributes.email;
        const tenant= value.attributes["custom:company"];
        setUsername(value.username);
        setSubPlan("pro")
  
        console.log(approvalStatus);
        console.log(accStatus)
        setTenant(tenant)
        setApprovalStatus(approvalStatus);
        setAccStatus(accStatus);
        setUserEmail(email);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching user info:", err);
        setLoading(false);
      });

  }, []);

  useEffect(()=>{
    getData();
    fetchEventList();
  },[tenant])


  const getData = async () => {
    try {
      // Fetch all events and filter by tenant
      const eventResponse = await axios.get("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getEvents");
      const eventList = eventResponse.data.filter(event => event.tenant === tenant);
  
      // Initialize a variable to count all certificates
      let totalCertificatesCount = 0;
      let totalUserCount = 0;
  
      // Fetch certificates for each event and count them
      for (const event of eventList) {
        try {
          const certResponse = await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getCert2", {
            event: event.id,
            tenant: tenant
          });
          const certificates = certResponse.data;
          // Add the count of certificates for this event to the total count
          totalCertificatesCount += certificates.length;

          console.log(event.name);

          readRemoteFile("https://certificatesys.s3.ap-southeast-1.amazonaws.com/" + event.id + ".csv" + "?_=" + (new Date).getTime(), {
            complete: (results) => {
              const filteredData = results.data.filter(arr => arr.length > 1);
              console.log(filteredData);
              totalUserCount += filteredData.length - 1;
            },
          });

        } catch (error) {
          console.error(`Error fetching certificates for event ${event.id}:`, error);
        }
      }
  
      setCountCert(totalCertificatesCount);
      setUserCount(totalUserCount);
  
      // You can set the total certificates count to a state if needed
      // setTotalCertificatesCount(totalCertificatesCount);
  
      // Set the count of filtered events
      setEventCount(eventList.length);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  }


  const fetchEventList = async () => {
    try {
      const response = await axios.get("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getEvents");
      const eventList = response.data
        .filter(event => event.tenant === tenant) // Filter events by tenant
        .map(event => ({
          Event: event.name,
          Date: event.date,
          Location: event.location,
          Actions: (
            <>
              <SuiButton variant="text" color="success" size="small" onClick={() => handleEdit(event.id,event.name)}>
                <Icon>edit</Icon>
              </SuiButton>
            </>
          ),
        }));

      setEvents(eventList);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };

  const handleChange = (file) => {
    handleFileUpload(file);
  };

  const handleFileUpload = async (file) => {
    if (file && userEmail) {
      const fileName = file.name;
      const fileType = file.type;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        const fileContent = reader.result.split(',')[1];

        try {
          console.log(tenant)
          const response = await axios.post('https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/uploadSsm', {
            username: username,
            company: tenant,
            email: userEmail,
            fileName: fileName,
            fileContent: fileContent,
            fileType: fileType,
            fileCategory: "ssm"
          });

          if (response.status === 200) {
            console.log("File uploaded successfully");          
            setIsModalOpen(false);
            enqueueSnackbar('Your file have been uploaded', {
              variant: 'info',
            }) // Close the modal after uploading the file
          } else {
            console.error("Error uploading file:", response.data.message);
          }
        } catch (err) {
          console.error("Error uploading file:", err);
        }
      };
    }
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };


  const eventColumns = [
    { name: "Event", align: "left" },
    { name: "Date", align: "left" },
    { name: "Location", align: "center" },
    { name: "Actions", align: "center" },
  ];




  const handleEdit = (eventId,eventName) => {
    console.log(`Edit event ${eventId} - ${eventName}`);
    navigate(`/events/${eventId}`, { state: { eventName } });
    
  };

  const handleView = (eventId) => {
    console.log(`View event ${eventId}`);
    // Implement view event functionality here
  };

  const steps = [
    'Upload SSM file to verify',
    'SSM been verify',
    'Create an event to generate credential',
  ];

  
if ((approvalStatus === "1" || approvalStatus === "2") && accStatus === "organizer") {
  return (
    <DashboardLayout>
      <Header />
      <SuiBox 
        my={5}
        py={3}
        p={2} 
        bgColor={"white"}                   
        borderRadius="xl" 
        display="flex"
        flexDirection="column"
      >
        <Grid container>    
          {approvalStatus === "2" ? (
            <>
            <Grid item xs={12} sm={12} xl={12} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <SuiTypography variant="h4" fontWeight="medium" pt={2}>
                  Company Verification
                </SuiTypography>
                <SuiBox sx={{ width: '100%' }}>
                <Stepper activeStep={1} alternativeLabel>
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
                </SuiBox>
            </Grid>
            <Grid item xs={12} sm={6} xl={6} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <SuiTypography>
              Your verification in progress
            </SuiTypography>
            <SuiTypography variant="caption" textAlign="center">
            The verification process will take 3-5 business days.
            </SuiTypography>
            </Grid>
            </>
          ) : (
            <>
            <Grid item xs={12} sm={12} xl={12} display="flex" flexDirection="column" alignItems="center">
            <SuiTypography variant="h4" fontWeight="medium" pt={2}>
              Company Verification
            </SuiTypography>
            <SuiBox sx={{ width: '100%' }}>
            <Stepper activeStep={0} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            </SuiBox>
        </Grid>
            <Grid item xs={12} sm={6} xl={6} p={12} display="flex" flexDirection="column" alignItems="center" justifyContent="center" >
              <SuiTypography>
                Please complete the SSM verification
              </SuiTypography>
              <SuiTypography variant="caption" textAlign="center">
              To verify your company's authenticity, please upload a copy of your company's SSM (Suruhanjaya Syarikat Malaysia) registration.
              </SuiTypography>
              <SuiBox pt={3}>
              <SuiButton color="dark" onClick={handleOpenModal}>
                Verify Now
              </SuiButton>
              </SuiBox>
              </Grid>
              
            </>
          )}
          
          <Grid item xs={12} sm={6} xl={6} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            {/* Display your verification image */}
            <Lottie animationData={uploadJson} style={{ width: 400, height: 400 }} />
            {/* <img src={uploadGif} height={200}/> */}
          </Grid>
        </Grid>
      </SuiBox>
      {/* <Footer /> */}
      <Modal open={isModalOpen} onClose={handleCloseModal} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <SuiBox my="auto" mx="auto" py={3} p={2} bgColor={"white"} borderRadius="xl" display="flex" flexDirection="column">
          <SuiBox>
          <SuiTypography variant="h5" fontWeight="medium">
            Upload SSM
          </SuiTypography>
          <SuiTypography variant="caption">
            File should be a PDF format
          </SuiTypography>
          </SuiBox>
          <SuiBox p={3}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              // Reset the form (if needed, depending on your specific use case)
              e.target.reset();
            }}
          >
            <FileUploader
              handleChange={handleChange}
              name="file"
              types={['PDF']}
            />
            <SuiButton type="submit" variant="outlined" color="info" size="small" style={{ marginTop: '10px' }}>
              Upload
            </SuiButton>
          </form>
          </SuiBox>
        </SuiBox>
      </Modal>
    </DashboardLayout>
  );
}

if (approvalStatus === "3" && accStatus === "organizer") {
  return (
    <DashboardLayout>
    <Header />
    <SuiBox py={3}>
      <SuiBox mb={3}>
      {subscriptionPlan === "pro" && (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4} xl={4}>
            <MiniStatisticsCard
              title={{ text: "Total Events" }}
              count={eventCount}
              //percentage={{ color: "success", text: "+55%" }}
              icon={{ color: "primary", component: "emoji_events" }}
            />
          </Grid>
          <Grid item xs={12} sm={4} xl={4}>
            <MiniStatisticsCard
              title={{ text: "Total Certificates" }}
              count={certCount}
              //percentage={{ color: "success", text: "+3%" }}
              icon={{ color: "primary", component: "card_membership_icon" }}
            />
          </Grid>
          <Grid item xs={12} sm={4} xl={4}>
            <MiniStatisticsCard
              title={{ text: "Active Users" }}
              count={userCount}
              //percentage={{ color: "error", text: "-2%" }}
              icon={{ color: "primary", component: "people" }}
            />
          </Grid>
        </Grid>
        )}
      </SuiBox>
      <SuiBox mb={3}>
        <Grid container spacing={3}>
          {/* <Grid item xs={12} lg={5}>
            <ReportsBarChart
              title="active users"
              description={
                <>
                  (<strong>+23%</strong>) than last week
                </>
              }
              chart={chart}
              items={items}
            />
          </Grid> */}
          <Grid item xs={12} lg={12}>
                <Card>
          <SuiBox p={3}>
            <SuiTypography component="label" fontWeight="bold">
                        My Events
                      </SuiTypography>
                <SuiButton onClick={fetchEventList} style={{float:"right"}} variant="gradient" color="dark">                    
                        <Icon sx={{ fontWeight: "bold" }}>refresh</Icon>
                        </SuiButton>
            </SuiBox>   
                  {events.length === 0 ? ( // Conditionally render the message when rows array is empty
                    <SuiBox p={10}>
                      <SuiTypography variant="h5" color="secondary" textAlign="center" mt={2}>
                      There are no event yet.
                      </SuiTypography>
                    </SuiBox>   
                    ) : (
                      <SuiBox px={2} pb={4}>
                        <Table columns={eventColumns} rows={events} />
                      </SuiBox>
                    )}
          </Card>
            {/* <GradientLineChart
              title="Sales Overview"
              description={
                <SuiBox display="flex" alignItems="center">
                  <SuiBox fontSize={size.lg} color="success" mb={0.3} mr={0.5} lineHeight={0}>
                    <Icon className="font-bold">arrow_upward</Icon>
                  </SuiBox>
                  <SuiTypography variant="button" color="text" fontWeight="medium">
                    4% more{" "}
                    <SuiTypography variant="button" color="text" fontWeight="regular">
                      in 2021
                    </SuiTypography>
                  </SuiTypography>
                </SuiBox>
              }
              height="20.25rem"
              chart={gradientLineChartData}
            /> */}
          </Grid>
        </Grid>
      </SuiBox>
    </SuiBox>
    {/* <Footer /> */}
  </DashboardLayout>
  );
}

if (accStatus === "Admin" ) {
  // Render content for Admin
  return (
    <DashboardLayout>
    <Header />
    <SuiBox py={3}>
      <SuiBox mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} xl={3}>
            <MiniStatisticsCard
              title={{ text: "total certificate" }}
              count="3,000"
              //percentage={{ color: "success", text: "+55%" }}
              icon={{ color: "primary", component: "paid" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} xl={3}>
            <MiniStatisticsCard
              title={{ text: "total users" }}
              count="1,300"
              //percentage={{ color: "success", text: "+3%" }}
              icon={{ color: "primary", component: "public" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} xl={3}>
            <MiniStatisticsCard
              title={{ text: "Total organizer" }}
              count="14"
              //percentage={{ color: "error", text: "-2%" }}
              icon={{ color: "primary", component: "emoji_events" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} xl={3}>
            <MiniStatisticsCard
              title={{ text: "sales" }}
              count="RM13,430"
              //percentage={{ color: "success", text: "+5%" }}
              icon={{
                color: "primary",
                component: "shopping_cart",
              }}
            />
          </Grid>
        </Grid>
      </SuiBox>
      <SuiBox mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={5}>
            <ReportsBarChart
              color="primary"
              title="active users"
              description={
                <>
                  (<strong>+23%</strong>) than last week
                </>
              }
              chart={chart}
              items={items}
            />
          </Grid>
          <Grid item xs={12} lg={7}>
            <GradientLineChart
              title="User Overview"
              description={
                <SuiBox display="flex" alignItems="center">
                  <SuiBox fontSize={size.lg} color="success" mb={0.3} mr={0.5} lineHeight={0}>
                    <Icon className="font-bold">arrow_upward</Icon>
                  </SuiBox>
                  <SuiTypography variant="button" color="text" fontWeight="medium">
                    4% more{" "}
                    <SuiTypography variant="button" color="text" fontWeight="regular">
                      in {new Date().getFullYear()}
                    </SuiTypography>
                  </SuiTypography>
                </SuiBox>
              }
              height="20.25rem"
              chart={gradientLineChartData}
            />
          </Grid>
        </Grid>
      </SuiBox>
    </SuiBox>
    {/* <Footer /> */}
  </DashboardLayout>
  );
}

// Render content for other cases (approvalStatus !== "1" or accStatus !== "organizer")
return (
  <DashboardLayout>
    <Header />
    <SuiBox py={3}>
      {/* <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <SuiBox mt={4}>{ProjectsPast("Past Events")}</SuiBox>
        </Grid>
      </Grid> */}
    </SuiBox>
    {/* <Footer /> */}
  </DashboardLayout>
);
}

export default Overview;
